import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Declaration, DeclarationGoods, ICommodityCodeData, RecursivePartial } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  partialDeclaration: RecursivePartial<Declaration>;
  partialGoodsShipmentItem: RecursivePartial<DeclarationGoods>;
  commodityCodes: ICommodityCodeData[];
}

export const useSaveFinalizeDataToAllDeclarations = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ batchId, partialDeclaration, partialGoodsShipmentItem, commodityCodes }: HookProps) => {
      await request({
        path: `batches/${batchId}/save-finalize-data-to-all-declarations`,
        method: 'PATCH',
        authenticate: true,
        dataObject: { partialDeclaration, partialGoodsShipmentItem, commodityCodes },
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.partialDeclaration._id] });
      queryClient.invalidateQueries({ queryKey: ['retrieve-declaration-finalize'] });
      queryClient.invalidateQueries({ queryKey: ['batches'] });

      toast.success('Finalize data saved');
    },
    onError: (error) => {
      showErrorToast(error, 'Could not save finalize data');
    },
  });
};
